(function(){
  if(window.__radLoaded) return;
  window.__radLoaded = true;

  function init(){
    if(typeof gsap==='undefined'||typeof ScrollTrigger==='undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    var reduced=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if(reduced) return revealAll();

    var root=document.getElementById('rad-home');
    if(!root) return;

    var hasHover=window.matchMedia('(hover:hover)').matches;

    // Grid parallax
    var grid=document.getElementById('rad-grid');
    if(grid){
      gsap.to(grid,{
        yPercent:-12,ease:'none',
        scrollTrigger:{trigger:root,start:'top top',end:'bottom bottom',scrub:2}
      });
    }

    // Hero entrance
    var tl=gsap.timeline({defaults:{ease:'power4.out'}});
    var ey=document.getElementById('rad-eyebrow');
    if(ey) tl.to(ey,{clipPath:'inset(0 0 0% 0)',duration:0.7},0.1);
    var inners=root.querySelectorAll('.rh1-inner');
    if(inners.length) tl.to(inners,{y:0,duration:0.9,stagger:0.12},0.3);
    var sub=document.getElementById('rad-sub');
    if(sub) tl.to(sub,{opacity:1,y:0,duration:0.7},0.9);
    var ctas=document.getElementById('rad-ctas');
    if(ctas) tl.to(ctas,{opacity:1,y:0,duration:0.6},1.1);

    // Hero left parallax on scroll
    var heroLeft=root.querySelector('.rh-left');
    if(heroLeft){
      gsap.to(heroLeft,{
        y:-50,ease:'none',
        scrollTrigger:{trigger:'.rh',start:'top top',end:'bottom top',scrub:1.4}
      });
    }

    // ScrollTrigger helpers
    function onEnter(el,vars,trigger,start){
      ScrollTrigger.create({
        trigger:trigger||el,start:start||'top 88%',once:true,
        onEnter:function(){gsap.to(el,vars);}
      });
    }
    function batchEnter(els,vars,stagger,trigger){
      if(!els.length) return;
      ScrollTrigger.create({
        trigger:trigger||els[0],start:'top 88%',once:true,
        onEnter:function(){
          gsap.to(els,Object.assign({},vars,{stagger:stagger||0.08}));
        }
      });
    }

    // Labels
    root.querySelectorAll('.rlabel').forEach(function(el){
      onEnter(el,{clipPath:'inset(0 0% 0 0)',duration:0.7,ease:'power3.out'});
    });
    // H2 lines
    root.querySelectorAll('.rh2-inner').forEach(function(el){
      onEnter(el,{y:0,duration:0.8,ease:'power4.out'});
    });
    // Rules
    root.querySelectorAll('.rrule').forEach(function(el){
      onEnter(el,{width:40,duration:0.9,ease:'power3.out'});
    });
    // Body paras
    root.querySelectorAll('.rp').forEach(function(el){
      onEnter(el,{opacity:1,y:0,duration:0.7,ease:'power3.out'});
    });
    // Vehicle cards
    var vcs=root.querySelectorAll('.rvc,.rvc-all');
    if(vcs.length) batchEnter(vcs,{clipPath:'inset(0 0 0% 0)',duration:0.65,ease:'power3.out'},0.07);
    // Why cards
    var whys=root.querySelectorAll('.rwhy-card');
    if(whys.length){
      ScrollTrigger.create({
        trigger:whys[0],start:'top 85%',once:true,
        onEnter:function(){
          gsap.to(whys,{opacity:1,y:0,rotation:0,duration:0.75,stagger:0.1,ease:'back.out(1.4)'});
        }
      });
    }
    // Price block
    var pb=root.querySelector('.rprice');
    if(pb){
      onEnter(pb,{clipPath:'inset(0 0% 0 0)',duration:0.85,ease:'power3.out'});
      var lis=pb.querySelectorAll('li');
      if(lis.length){
        ScrollTrigger.create({
          trigger:pb,start:'top 80%',once:true,
          onEnter:function(){
            gsap.to(lis,{opacity:1,x:0,duration:0.45,stagger:0.09,ease:'power2.out'});
          }
        });
      }
    }
    // Use cells
    var cells=root.querySelectorAll('.ruse-cell');
    if(cells.length) batchEnter(cells,{opacity:1,y:0,duration:0.55,ease:'power3.out'},0.07);
    // FAQ
    var qas=root.querySelectorAll('.rqa-item');
    if(qas.length) batchEnter(qas,{opacity:1,y:0,duration:0.55,ease:'power3.out'},0.09);
    // Section CTAs
    root.querySelectorAll('.rsec-cta').forEach(function(el){
      onEnter(el,{opacity:1,duration:0.6},el,'top 90%');
    });
    // Brand
    var bb=root.querySelector('.rbrand-badge');
    if(bb) onEnter(bb,{opacity:1,y:0,duration:0.6});
    root.querySelectorAll('.rbrand-h2 span').forEach(function(el){
      onEnter(el,{y:0,duration:0.8,ease:'power4.out'});
    });
    var bp=root.querySelector('.rbrand-p');
    if(bp) onEnter(bp,{opacity:1,duration:0.65});
    var bv=root.querySelector('.rbrand-verse');
    if(bv) onEnter(bv,{opacity:1,duration:0.6},bv,'top 90%');
    var bc=root.querySelector('.rbrand-ctas');
    if(bc) onEnter(bc,{opacity:1,duration:0.55},bc,'top 90%');
    // Final
    var fe=root.querySelector('.rfinal-eye');
    if(fe) onEnter(fe,{opacity:1,duration:0.6});
    root.querySelectorAll('.rfinal-h2 span').forEach(function(el){
      onEnter(el,{y:0,duration:0.85,ease:'power4.out'});
    });
    var fp=root.querySelector('.rfinal-p');
    if(fp) onEnter(fp,{opacity:1,duration:0.6},fp,'top 90%');
    var fc=root.querySelector('.rfinal-ctas');
    if(fc) onEnter(fc,{opacity:1,duration:0.55},fc,'top 90%');

    // Hero video init
    initHeroVideo();

    // Magnetic buttons
    if(hasHover){
      root.querySelectorAll('.rad-mag').forEach(function(btn){
        var qx=gsap.quickTo(btn,'x',{duration:0.35,ease:'power3.out'});
        var qy=gsap.quickTo(btn,'y',{duration:0.35,ease:'power3.out'});
        var rx,ry,rw,rh;
        btn.addEventListener('mouseenter',function(){
          var r=btn.getBoundingClientRect();
          rx=r.left;ry=r.top;rw=r.width;rh=r.height;
        });
        btn.addEventListener('mousemove',function(e){
          qx((e.clientX-rx-rw/2)*0.34);
          qy((e.clientY-ry-rh/2)*0.34);
        });
        btn.addEventListener('mouseleave',function(){qx(0);qy(0);});
        btn.addEventListener('mousedown',function(){
          gsap.to(btn,{scale:0.94,duration:0.08,ease:'power2.in'});
        });
        btn.addEventListener('mouseup',function(){
          gsap.to(btn,{scale:1,duration:0.38,ease:'back.out(2.8)'});
        });
      });
      root.querySelectorAll('.rvc').forEach(function(card){
        card.addEventListener('mouseenter',function(){gsap.to(card,{y:-6,duration:0.28,ease:'power2.out'});});
        card.addEventListener('mouseleave',function(){gsap.to(card,{y:0,duration:0.42,ease:'power3.out'});});
      });
      root.querySelectorAll('.rwhy-card').forEach(function(card){
        card.addEventListener('mouseenter',function(){gsap.to(card,{y:-7,duration:0.28,ease:'power2.out'});});
        card.addEventListener('mouseleave',function(){gsap.to(card,{y:0,duration:0.42,ease:'power3.out'});});
      });
    }

    ScrollTrigger.refresh();
  }

  function initHeroVideo(){
    var video=document.getElementById('rad-hero-video');
    if(!video) return;
    if(!window.matchMedia('(min-width:1281px)').matches) return;
    video.src='https://cdn.shopify.com/videos/c/o/v/9080734fddc94873ba731a19df83c68f.mp4';
    video.load();
    var p=video.play();
    if(p&&p.catch) p.catch(function(){});
  }

  function revealAll(){
    var root=document.getElementById('rad-home');
    if(!root) return;
    root.querySelectorAll(
      '.rh-eye,.rh1-inner,.rh-sub,.rh-ctas,.rlabel,.rh2-inner,.rp,'+
      '.rvc,.rvc-all,.rwhy-card,.rprice,.rlist li,.ruse-cell,.rqa-item,'+
      '.rsec-cta,.rbrand-badge,.rbrand-h2 span,.rbrand-p,.rbrand-verse,'+
      '.rbrand-ctas,.rfinal-eye,.rfinal-h2 span,.rfinal-p,.rfinal-ctas'
    ).forEach(function(el){
      el.style.opacity='1';
      el.style.transform='none';
      el.style.clipPath='none';
      if(el.classList.contains('rrule')) el.style.width='40px';
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  } else {
    init();
  }

})();
